import tracking from "../../../../../../common/ts/core/tracking";
import {EventBus} from "../../../../../../common/ts/events/EventBus";
import dom from "../../../../../../common/ts/core/dom";
import {SaveEmailAlertRequestedEvent} from "../main/events";
import {FullPageModalCloseEvent} from "../../../../../../common/ts/events/Events";
import {
    ALERT_CREATION_SECTION_ADPAGE_BOX,
    ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT,
    ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM,
    ALERT_CREATION_SECTION_MOBILE_BOTTOM,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP,
    ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2,
    ALERT_CREATION_UNKNOWN_SECTION
} from "./constants";
import {WlModal} from "../../../../../../common/ts/webcomponents/modal/modal.component";

let eventBus: EventBus;

export function init(ev: EventBus = EventBus.getInstance()) {
    eventBus = ev;
}
function initializeRetentionForm(formId: string, email: string | null) {
    if(!email) {
        return;
    }

    eventBus.emit(new dom.PopulateFormEvent({
        selector: `#${formId}`,
        data: [['email', email]],
    }));
}

function submitRetentionForm(
    formId: string,
    formData: FormData,
    emailRetentionSubmitTrackingName: string,
    isPaid: boolean,
    openedFrom: string,
    isDesktop: boolean,
) {
    trackSubmitEvent(emailRetentionSubmitTrackingName);
    trackSaveSearchWebTrackingEvents(isPaid, openedFrom, isDesktop);
    const search = formData.get("search")?.toString();
    const email = formData.get("email")?.toString();
    const wantNews = formData.get("accept-news") === "on";

    if (search && email) {
        eventBus.emit(new dom.SetContentEvent({ selector: "#confirm__search", content: search }));
        eventBus.emit(new dom.SetContentEvent({ selector: "#confirm__email__value", content: email }));
        eventBus.emit(new dom.HideEvent({ selector: `#${formId}` }));
        eventBus.emit(new dom.ShowEvent({ selector: `#${formId}__alert-created` }));
        eventBus.emit(new SaveEmailAlertRequestedEvent({ searches: [search], email, wantNews }));
        eventBus.emit(new FullPageModalCloseEvent({ id: "email-retention-modal" }));
    }
}

function clickSaveActualSearchCTA(
    saveActualSearchFormId:string,
    emailValue: string,
    isPaid: boolean,
    isDesktop:boolean
){
    let alertSection = getSavedAlertEventSection(isPaid, saveActualSearchFormId, isDesktop);
    eventBus.emitMany([
        new dom.PopulateFormEvent({
            selector: `#${saveActualSearchFormId}`,
            data: [['email', emailValue]],
        }),
        new tracking.TrackWebTrackingEvent({
            section: alertSection.keys().next().value,
            sectionName: alertSection.values().next().value,
            type: "AlertButtonClicked",
            serpUrl: window.location.href,
        }),
        new tracking.TrackAnalyticsEvent({
            name: 'save-actual-search-cta',
        })
    ]);
}

function submitSaveActualSearchForm(
    formData: FormData,
    emailRetentionSubmitTrackingName: string,
    isPaid: boolean,
    openedFrom: string,
    isDesktop: boolean,
) {
    trackSubmitEvent(emailRetentionSubmitTrackingName);
    trackSaveSearchWebTrackingEvents(isPaid, openedFrom, isDesktop);
    const search = formData.get("search")?.toString();
    const email = formData.get("email")?.toString();

    if (search && email) {
        let saveSimilarSearchesModal = document.querySelector<WlModal>('#js_save-similars-searches-modal')!
        eventBus.emit(new SaveEmailAlertRequestedEvent({searches: [search], email, wantNews:true}));
        localStorage.setItem("email", email);
        saveSimilarSearchesModal.open();
        let saveSimilarSearchesCloseButton = document.querySelector(".save-similar-searches-close");
        saveSimilarSearchesCloseButton?.addEventListener("click", () => {
            saveSimilarSearchesModal?.close();
        });
    }
}

function getSavedAlertEventSection(
    isPaid: boolean,
    retentionFormOpenedFrom: string,
    isDesktop: boolean,
): Map<string, string> {
    let toReturn = new Map<string, string>();
    if (isDesktop) {
        if (retentionFormOpenedFrom === "desktop-auto-show") {
            return toReturn.set(ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP.toString(), "ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP");
        }

        if (retentionFormOpenedFrom === "desktop-floating") return toReturn.set(ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM.toString(), "ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM");
        if (retentionFormOpenedFrom === "detail-traffic-email-retention-form") return toReturn.set(ALERT_CREATION_SECTION_ADPAGE_BOX.toString(),"ALERT_CREATION_SECTION_ADPAGE_BOX");
        if (retentionFormOpenedFrom === "save-actual-search-form") return toReturn.set(ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2.toString(),"ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2");
        if (retentionFormOpenedFrom === "save-actual-search-form-adpage") return toReturn.set(ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT.toString(),"ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT");
        if (retentionFormOpenedFrom === "desktop-top") {
            if(isPaid) return toReturn.set(ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2.toString(), "ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2");
            return toReturn.set(ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2.toString(), "ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2");
        }

        return toReturn.set(ALERT_CREATION_UNKNOWN_SECTION.toString(),"ALERT_CREATION_UNKNOWN_SECTION");
    } else {
        if (retentionFormOpenedFrom === "save-actual-search-form") return toReturn.set(ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2.toString(), "ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2");
        if (retentionFormOpenedFrom === "save-actual-search-form-adpage") return toReturn.set(ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT.toString(), "ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT");
        if (retentionFormOpenedFrom === "email-retention-form--mobile" || retentionFormOpenedFrom === "save-actual-search-form") {
            if(isPaid) return toReturn.set(ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM.toString(), "ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM");
            return toReturn.set(ALERT_CREATION_SECTION_MOBILE_BOTTOM.toString(), "ALERT_CREATION_SECTION_MOBILE_BOTTOM");
        }

        if (retentionFormOpenedFrom === "detail-traffic-email-retention-form") {
            return toReturn.set(ALERT_CREATION_SECTION_ADPAGE_BOX.toString(), "ALERT_CREATION_SECTION_ADPAGE_BOX");
        }

        return toReturn.set(ALERT_CREATION_UNKNOWN_SECTION.toString(), "ALERT_CREATION_UNKNOWN_SECTION");
    }
}

function changeRetentionToggle(eventTarget: HTMLInputElement, emailRetentionToggleTrackingName: string) {
    if (eventTarget && eventTarget.checked) {
        trackToggleAcceptNewsEvent(emailRetentionToggleTrackingName);
    }
}

function trackToggleAcceptNewsEvent(emailRetentionToggleTrackingName: string) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: emailRetentionToggleTrackingName,
    }));
}

function trackSubmitEvent(emailRetentionSubmitTrackingName: string) {
    eventBus.emit(
        new tracking.TrackAnalyticsEvent({name: emailRetentionSubmitTrackingName})
    )
}

function trackSaveSearchWebTrackingEvents(
    isPaid: boolean,
    retentionFormOpenedFrom: string,
    isDesktop: boolean,
) {
    let alertSection = getSavedAlertEventSection(isPaid, retentionFormOpenedFrom, isDesktop);
    eventBus.emit(new tracking.TrackWebTrackingEvent({
        section: alertSection.keys().next().value,
        sectionName: alertSection.values().next().value,
        type: "SearchSaved",
        serpUrl: window.location.href,
    }))
}

export default {
    init,
    initializeRetentionForm,
    getSavedAlertEventSection,
    submitRetentionForm,
    changeRetentionToggle,
    clickSaveActualSearchCTA,
    submitSaveActualSearchForm,
};
